import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment.dev';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // console.log("sessss",sessionStorage.getItem("authToken"));
    
    let val:any =sessionStorage.getItem("authToken")        
    let modifiedRequest = request.clone({
        setHeaders:{
          'Authorization': val,
          'Access-Control-Allow-Origin':'*',
          // 'Access-Control-Allow-Origin':"http://localhost:4200, https://wa-ui-dsc-rmt-dev.azurewebsites.net",
          'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
          'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
          'X-Content-Type-Options':"nosniff",
          "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
          "X-XSS-Protection":" 1; report=<reporting-uri>",
          'X-Frame-Options': "SAMEORIGIN",
          'Content-Security-Policy':"default-src 'self' http://localhost:4200, https://wa-ui-dsc-rmt-dev.azurewebsites.net,https://wa-ui-dsc-rmt.azurewebsites.net,https://www.fi2m-dev.rmt.dhl.com,https://www.fi2m.rmt.dhl.com, *",
          // 'Content-Encoding':"gzip;q=1.0, *; compress, br",
          // 'Content-Type':'application/json,application/x-www-form-urlencoded,multipart/form-data,text/plain,application/octet-stream',
          // 'Content-Type':lastItem==='agreement-file-upload' ? 'application/json,multipart/form-data': 'application/json',
          'Accept':'application/json',
          'X-CSRF-Token': this.getCsrfTokenFromCookie(),
        }
      })
      if (request.body instanceof FormData) {
        // Clone the request without setting 'Content-Type' (let the browser set it automatically)
        modifiedRequest = request.clone({
          headers: request.headers.delete('Content-Type'),
          setHeaders:{
            'Authorization': val,
            'Access-Control-Allow-Origin':"http://localhost:4200, https://wa-ui-dsc-rmt-dev.azurewebsites.net, https://www.fi2m-dev.rmt.dhl.com, https://www.fi2m.rmt.dhl.com, https://wa-ui-dsc-rmt.azurewebsites.net,https://*.dhl.com",
            'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
            'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
            'X-Content-Type-Options':"nosniff",
            "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
            "X-XSS-Protection":" 1; report=<reporting-uri>",
            'X-Frame-Options': "SAMEORIGIN",
            'Content-Security-Policy':"default-src 'self' http://localhost:4200,https://www.fi2m-dev.rmt.dhl.com, https://www.fi2m.rmt.dhl.com, https://wa-ui-dsc-rmt-dev.azurewebsites.net,https://wa-ui-dsc-rmt.azurewebsites.net, *,https://*.dhl.com",
            'X-CSRF-Token':this.getCsrfTokenFromCookie(),
          }
        });
      }
      else{
        modifiedRequest = request.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            'Authorization': val,
            // 'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Origin':"http://localhost:4200, https://wa-ui-dsc-rmt-dev.azurewebsites.net,https://www.fi2m-dev.rmt.dhl.com, https://www.fi2m.rmt.dhl.com, https://wa-ui-dsc-rmt.azurewebsites.net,https://*.dhl.com",
            'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
            'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
            'X-Content-Type-Options':"nosniff",
            "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
            "X-XSS-Protection":" 1; report=<reporting-uri>",
            'X-Frame-Options': "SAMEORIGIN",
            'Content-Security-Policy':"default-src 'self' http://localhost:4200, https://wa-ui-dsc-rmt-dev.azurewebsites.net,https://www.fi2m-dev.rmt.dhl.com, https://www.fi2m.rmt.dhl.com, https://wa-ui-dsc-rmt.azurewebsites.net, *,https://*.dhl.com",
            // 'Content-Encoding':"gzip;q=1.0, *; compress, br",
            // 'Content-Type':'application/json,application/x-www-form-urlencoded,multipart/form-data,text/plain,application/octet-stream',
            // 'Content-Type':lastItem==='agreement-file-upload' ? 'application/json,multipart/form-data': 'application/json',
            'Accept':'application/json',
            'X-CSRF-Token':this.getCsrfTokenFromCookie(),
          }
        });
        // console.log("modifiedRequest",modifiedRequest);
        
      }


      return next.handle(modifiedRequest).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // const contentType = event.headers.get('Content-Type');
            // if (contentType && contentType.startsWith('application/octet-stream')) {
            //   const contentDisposition = event.headers.get('Content-Disposition');
            //   const filename = contentDisposition ? contentDisposition.split('filename=')[1] : null;
            //   saveAs(event.body, filename?filename:'file');
            // }
          }
        })
      );
  }

  private getCsrfTokenFromCookie(): string {
    const match = document.cookie.match(new RegExp('(^| )' + environment.CSRF_TOKEN_NAME + '=([^;]+)'));
    // return match ? match[2] : ''; 
    let token = sessionStorage?.getItem("csrf-token")
    return token?token: '';
  }
}
